import React from 'react'
import injectStyles from 'react-jss'

import { Col, Row } from 'react-bootstrap'
import Table from 'rc-table'
import { SectionTitle } from 'Components/Section/SectionTitle'
import SubmitButton from 'Components/Form/SubmitButton'
import { Checkbox } from '../../../../../Components/Form'
import ProgramForm from '../ProgramsForm'
import { CITY_PROGRAMS } from '../options'
import styles from './styles'

const CityProgramView = ({
  tableData = [],
  tableColumns,
  errors = [],
  onSubmit,
  onToggle,
  exportLink,
  isActive,
  classes,
  programType,
  onUpdate,
  maxBudget,
  isDisabled,
}) => (
  <div className="city-referral-section">
    <Row className={classes.headingRow}>
      <Col xs={3} className={classes.sectionTitle}>
        <SectionTitle>
          {programType === CITY_PROGRAMS.REFERRAL ? 'BA Referral' : 'BA Promo'}
        </SectionTitle>
      </Col>
      {isActive && (
        <Col xs={1} className={classes.toggleWrapper}>
          <label className={classes.toggleLabel}>Active</label>
          <Checkbox
            initValue={isActive}
            input={{
              onClick: onToggle,
              defaultChecked: isActive,
              value: isActive,
            }}
          />
        </Col>
      )}
      <Col float="right" xs={11}>
        <a className={classes.exportButton} href={exportLink} type="button">
          <SubmitButton value="Export" />
        </a>
      </Col>
    </Row>
    {!isActive && (
      <Row className={classes.formWrapper}>
        <ProgramForm
          onSubmit={onSubmit}
          onUpdate={onUpdate}
          isDisabled={isDisabled}
          maxBudget={maxBudget}
          programType={programType}
        />
      </Row>
    )}
    <Table
      scroll={{ y: 200 }}
      rowClassName={(record, index) =>
        `bad-weather-row ${index % 2 ? '' : 'bg-grey'}`
      }
      rowKey="id"
      className="table-w-100 city-referral-table"
      data={tableData}
      columns={tableColumns}
    />
    {errors.length > 0 && <h3>Errors</h3>}
    <ul className="errors">
      {errors.map((error, index) => (
        <li key={error + index}>{error}</li>
      ))}
    </ul>
  </div>
)

export default injectStyles(styles)(CityProgramView)



// WEBPACK FOOTER //
// ./src/Containers/Form/City/CityPrograms/CityProgramView/index.js